import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_TRANSFER } from 'shared/constants/common';
import TransfersItem from './TransfersItem';

export default function Transfers({ transfersList = [] }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_TRANSFER}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionTitle label="Transfers" className="ml-[10px] mt-1" />
      </div>
      {transfersList.map((transfer, index) => (
        <div
          key={`${index + 1}`}
          className={`${
            transfersList.length === index + 1 ? 'md:mt-[40px]' : 'mt-[40px]'
          } `}
        >
          <TransfersItem transfer={transfer} />
        </div>
      ))}
    </>
  );
}
